<!--
  消息中心 - 公告通知
  add by lty
  2019-0906
 -->
<template>
  <div style="width:1628px;">
    <div>
      <span class="xbed-sub-title">公告通知列表</span>
    </div>
    
    <div class="xbed-breadcrumb">
			<Breadcrumb>
				<BreadcrumbItem>消息中心</BreadcrumbItem>
				<BreadcrumbItem>公告通知列表</BreadcrumbItem>
			</Breadcrumb>
		</div>
    <br>

    <Form inline class="i-form">
      <FormItem label="发送状态：" :label-width="100">
        <Select v-model="queryParams.sendState" clearable style="width:150px">
          <Option v-for="(item, index) in sendStatus" :key="index" :value="item.status">{{ item.value }}</Option>
        </Select>
      </FormItem>
      <FormItem :label-width="30">
        <Select v-model="dateType" style="width:100px">
          <Option v-for="(item, index) in dateSelect" :key="index" :value="item.type">{{ item.value }}</Option>
        </Select>
        <DatePicker type="daterange" v-model="dateTime" clearable :options="accountDateOptions" placeholder="请选择日期段、单天" class="date-time" style="width: 240px"></DatePicker>
      </FormItem>
      <FormItem label="关键字：" :label-width="100">
        <Input type="text" v-model.trim="queryParams.searchText" clearable placeholder="输入标题或创建人查询"></Input>
      </FormItem>
      <FormItem>
        <Button type="primary" @click="handleBtn" style="margin-left: 32px; width: 80px;">查询</Button>
      </FormItem>
      <FormItem>
        <Button type="primary" @click="addEditNotice('add')" style="width: 100px;">新建通知</Button>
      </FormItem>
    </Form>
    <!-- Table-->
    <Content>
      <!-- <Table ref="noticeModal" stripe :loading="consumloading" :columns="columns" :data="noticeListData" style="width:1615px;"></Table> -->
      <Table ref="noticeModal" stripe :loading="consumloading" :columns="columns" :data="noticeListData" style="width:1553px;"></Table>
      <div style="margin: 10px;overflow: hidden">
        <Page 
          show-sizer 
          show-total
          placement="top" 
          :total="listCount" 
          :current="queryParams.pageNum" 
          :page-size="queryParams.pageSize"
          @on-page-size-change="changePageSize" 
          @on-change="changePage"
        >
        </Page>
      </div>
    </Content>
    <!-- 新增/更改公告通知弹窗 -->
    <Modal ref="addOrEditModal" :loading="true" v-model="newNotice.modal" :mask-closable="false" :closable="false" :title="newNotice.type === 'add' ? '新建公告通知' : newNotice.type === 'edit'? '修改公告通知' : '公告通知详情'" width="700">
      <Form ref="noticeInfoForm" :rules="noticeValidate" :model="newNotice.formData">
        <FormItem label="通知终端：" :label-width="110">
          <CheckboxGroup v-model="newNotice.formData.noticeTarget">
            <Checkbox v-for="(item, index) in newNotice.terminalGroup" :key="index" :label="item.labal" :disabled="item.disabled">{{ item.value }}</Checkbox>
          </CheckboxGroup>
          <div v-if="newNotice.type === 'edit'" class="edit-tips">
            <span v-if="editSendState === 1" class="sp01">待发送</span>
            <span v-else class="sp02">已发送</span>
          </div>
          <div v-if="newNotice.type === 'detail'" class="edit-tips">
            <span class="sp03">已撤回</span>
          </div>
        </FormItem>
        <FormItem prop="title" label="通知标题：" :label-width="110">
          <Input type="text" v-model.trim="newNotice.formData.title" style="width:500px" :maxlength="50" placeholder="请输入通知标题"></Input>
        </FormItem>
        <FormItem prop="content" label="通知内容：" :label-width="110">
          <Input v-model.trim="newNotice.formData.content" type="textarea" style="width:500px" :autosize="{minRows: 6, maxRows: 10}" :maxlength="500" placeholder="输入消息内容"></Input>
        </FormItem>
        <FormItem prop="link" label="文章链接：" :label-width="110">
          <Input type="text" v-model.trim="newNotice.formData.link" placeholder="请粘贴文章链接" style="width:500px"></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button size="large" @click="closeNotice">取消</Button>
        <Button v-if="newNotice.type === 'add' || newNotice.type === 'edit'" type="primary" size="large" @click="addOrEdit" :loading="sureLoading">{{newNotice.type === 'add' ? '保存' : '确认修改'}}</Button>
      </div>
    </Modal>
  </div>  
</template>

<script>
  /* eslint-disable */
  import Moment from "moment";
  import Utils from "@/utils";
  import API from "@/api";
  export default {
    created() {
      this.username = Utils.findFromLocalStorage( "vue-username" );
      this.env = Utils.findFromLocalStorage( "env", "dev" );

      // 阿里云接口，header 传参（只有开发环境和测试环境需要传 group）
      this.protHeaders = {
        'x-ca-stage': Utils.aliHeaderEnv(this.env), 
        'Authorization': Utils.findFromLocalStorage("Author-token")
      }
      if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'testing') {
        this.protHeaders.group = process.env.NODE_ENV === 'development' ? 'dev' : 'qa'
      }
    },

    data() {
      const validateSelect = {
        title: (rule, value, callback) => {
          if (!this.newNotice.formData.title) {
            callback(new Error('请输入通知标题'));
          } else {
            callback();
          }
        },
        content: (rule, value, callback) => {
          if (!this.newNotice.formData.content) {
            callback(new Error('请输入通知内容'));
          } else {
            callback();
          }
        },
        link: (rule, value, callback) => {
          let _link = this.newNotice.formData.link
          if (_link && !(/^(http|https|\/\/)/.test(_link))) {
            callback(new Error('文章链接格式不正确，请检查是否填写完整（需填写http://或https://）以及其他错误'));
          } else {
            callback();
          }
        }
      }
      return {
        consumloading: false,
        sureLoading: false,
        editSendState: 0,
        dateTime: [ // 创建日期 & 更新时间
          Moment().subtract(1, 'month').format('YYYY-MM-DD'),
          Moment().format('YYYY-MM-DD')
        ],
        sendStatus: [
          {
            value: '全部',
            status: 'S00'
          },
          {
            value: '已发送',
            status: '2'
          },
          {
            value: '待发送',
            status: '1'
          },
          {
            value: '已撤回',
            status: '0'
          }
        ],
        dateSelect: [
          {
            value: '创建日期',
            type: '1'
          },
          {
            value: '更新日期',
            type: '2'
          }
        ],
        dateType: '1',
        queryParams: {
          pageNum: 1,
          pageSize: 10,
          sendState: 'S00', // 发送状态：1待发送，2已发送，0撤回
          createdTimeStart: '', // 创建时间开始
          createdTimeEnd: '', // 创建时间结束
          updatedTimeStart: '', // 修改时间开始
          updatedTimeEnd: '', // 修改时间结束
          searchText: '', // 标题，创建人，更新人
        },
        listCount: 0, // 分页
        accountDateOptions: {
          disabledDate (current) {
            return current && current.valueOf() > Date.now()
          }
        },
        noticeListData: [],
        newNotice: {
          modal: false,
          // typeName: '',
          type: '',
          // okText: '',
          // 终端组，目前只有一个
          terminalGroup: [
            {
              labal: 1,
              value: 'XMS-PC',
              disabled: true
            }
          ],
          formData: {
            noticeTarget: [1],
            title: '',
            content: '',
            createdName: '',
            updatedName: '',
            link: '',
            noticeId: 0
          }
        },
        columns: [
          {
            title: 'ID',
            key: 'noticeId',
            align: "center",
            width: 80
          },
          {
            title: '通知终端',
            key: 'noticeTarget',
            align: "center",
            width: 120,
            render: (h, params) => {
              let targetName = '-'
              this.newNotice.terminalGroup.map(item => {
                if (item.labal == params.row.noticeTarget) {
                  targetName = item.value
                }
              })
              return h('span', {}, targetName)
            }
          },
          {
            title: '标题',
            key: 'title',
            align: "center",
            width: 210
          },
          {
            title: '文章链接',
            key: 'link',
            align: "center",
            width: 210,
            render: (h, params) => {
              return h('a', {
                attrs: {
                  target: params.row.link ? '_blank' : '',
                  href: params.row.link ? params.row.link : 'javascript:;'
                }
              }, params.row.link ? params.row.link : '-')
            }
          },
          {
            title: '创建时间',
            key: 'createdTime',
            align: "center",
            width: 200,
            sortable: true
          },
          {
            title: '更新时间',
            key: 'updatedTime',
            align: "center",
            width: 200,
            sortable: true
          },
          {
            title: '发送状态',
            key: 'sendState',
            align: "center",
            width: 120,
            render: (h, params) => {
              let stateName = '-'
              this.sendStatus.map(item => {
                if (item.status == params.row.sendState) {
                  stateName = item.value
                }
              })
              return h('span', {
                attrs: {
                  class: 'send-state' + params.row.sendState
                }
              }, stateName)
            }
          },
          {
            title: '创建人',
            key: 'createdName',
            align: "center",
            width: 120
          },
          {
            title: '更新人',
            key: 'updatedName',
            align: "center",
            width: 120
          },
          {
            title: '操作',
            key: '',
            align: "center",
            width: 170,
            render: ( h, params ) => {
              if (params.row.sendState !== 0) {
                return h( "div", [
                  h(
                    "Button",
                    {
                      props: {
                        size: "small",
                        type: "primary"
                      },
                      style: {
                        marginRight: '12px'
                      },
                      on: {
                        click: () => {
                          this.addEditNotice('edit', params.row.noticeId)
                          this.editSendState = params.row.sendState
                        }
                      }
                    },
                    "修改"
                  ),
                  h(
                    "Button",
                    {
                      props: {
                        size: "small",
                        type: "primary"
                      },
                      on: {
                        click: () => {
                          if (params.row.sendState === 2) {
                            this.handleRecall(params.row.noticeId)
                          } else {
                            this.handleSend(params.row.noticeId)
                          }
                        }
                      }
                    },
                    params.row.sendState === 2 ? '撤回' : '发送'
                  )
                ] );
              } else {
                return h( "Button", {
                  props: {
                    size: "small",
                    type: "primary"
                  },
                  on: {
                    click: () => {
                      this.addEditNotice('detail', params.row.noticeId)
                    }
                  }
                },
                "详情" );
              }
            }
          },
        ],
        noticeValidate: {
          title: [
            {required: true, validator: validateSelect.title, trigger: 'blur' }
          ],
          content: [
            {required: true, validator: validateSelect.content, trigger: 'blur' }
          ],
          link: [
            {validator: validateSelect.link, trigger: 'blur'}
          ]
        },
      }
    },

    mounted() {
      this.$Notice.config({
        top: 150
      });
      this.getNoticeList()
    },

    methods: {
      // 获取公告列表数据
      async getNoticeList() {
        this.consumloading = true

        let _queryParams = this.queryParams
        if (this.dateType === '1') {
          // 创建时间
          _queryParams.createdTimeStart = this.dateTime[0] ? Moment(this.dateTime[0]).format('YYYY-MM-DD') : ''
          _queryParams.createdTimeEnd = this.dateTime[1] ? Moment(this.dateTime[1]).format('YYYY-MM-DD') : ''
          _queryParams.updatedTimeStart = _queryParams.updatedTimeEnd = ''

        } else if (this.dateType === '2') {
          // 更新时间
          _queryParams.updatedTimeStart = this.dateTime[0] ? Moment(this.dateTime[0]).format('YYYY-MM-DD') : ''
          _queryParams.updatedTimeEnd = this.dateTime[1] ? Moment(this.dateTime[1]).format('YYYY-MM-DD') : ''
          _queryParams.createdTimeStart = _queryParams.createdTimeEnd = ''
        }
        
        // 过滤空字段
        _queryParams = Object.keys(_queryParams).reduce(function(c, k) {
          if (_queryParams[k] && _queryParams[k] != 'S00' ) {
            c[k] = _queryParams[k]
          }
          return c
        }, {})

        try {
          const resp = (await API.omsAPI[this.env].clientServer.getNoticeList(_queryParams, this.protHeaders)).data;
          this.consumloading = false
          // console.info('resp:', resp)
          if ( resp.retCode ) {
            this.$Notice.error( {
              title: resp.msg,
              desc: '获取公告通知列表数据异常'
            })
            return
          }
          this.noticeListData = resp.list || []
          this.listCount = resp.total
        } catch(e) {
          this.consumloading = false
        }
      },
      // 查询按钮
      handleBtn() {
        this.queryParams.pageNum = 1
        this.getNoticeList()
      },

      // 新增/更改通知弹窗
      addEditNotice(type, noticeId) {
        this.newNotice.type = type
        if (type === 'edit' || type === 'detail') {
          this.newNotice.formData.noticeId = type === 'edit' ? noticeId : ''
          this.getNoticeDetail(noticeId)
        }
        this.newNotice.modal = true
      },

      // 检查必填项是否为空/内容是否填写正确
      validateResource(name) {
        let _res;
        this.$refs[name].validate((valid) => {
          _res = valid ? true : false
        })
        return _res;
      },

      // 关闭新增/修改弹窗时重置弹窗参数
      closeNotice() {
        let formData = this.newNotice.formData
        if ((this.newNotice.type === 'add' || this.newNotice.type === 'edit') && (formData.title || formData.content || formData.link)) {
          this.$Modal.confirm({
            title: '是否确认取消',
            content: '取消后，将不保存本次编辑的内容',
            okText: '确定',
            onOk: () => {
              this.newNotice.modal = false
              this.$refs.noticeInfoForm.resetFields();
            },
          });
        } else {
          this.newNotice.modal = false
          this.$refs.noticeInfoForm.resetFields();
        }
      },

      // 获取单条公告详情
      async getNoticeDetail(noticeId) {
        try {
          const resp = (await API.omsAPI[this.env].clientServer.noticeDetail({ noticeId: noticeId }, this.protHeaders)).data;
          // console.info('respsss:', resp)
          let formData = this.newNotice.formData
          formData.title = resp.title
          formData.content = resp.content
          formData.link = resp.link ? resp.link : ''

        } catch(e) {
          this.$Notice.error( {
            desc: '获取公告详情失败'
          })
        }
      },

      // 新增/更改弹窗确定按钮
      async addOrEdit() {
        if(!this.validateResource('noticeInfoForm')) {
          return
        }
        if (this.newNotice.type === 'add') {
          this.addOrUpdate()

        } else if (this.newNotice.type === 'edit') {
          this.$Modal.confirm({
            title: '是否确认修改信息',
            content: '修改信息后，原信息内容将会被覆盖',
            okText: '确认修改',
            onOk: () => {
              this.addOrUpdate()
            },
          });
        }
      },

      // 新增/更改公告接口操作
      async addOrUpdate() {
        this.sureLoading = true;

        let param = this.newNotice.formData
        // 过滤空字段
        param = Object.keys(param).reduce(function(c, k) {
          if (param[k]) {
            c[k] = param[k]
          }
          return c
        }, {})

        if (this.newNotice.type === 'add') {
          param.createdName = this.username
        } else if (this.newNotice.type === 'edit') {
          param.updatedName = this.username
          param.link = param.link ? param.link : ''
        }

        try {
          let resp = {}
          if (this.newNotice.type === 'add') {
            resp = (await API.omsAPI[this.env].clientServer.addNotice(param, this.protHeaders)).data;
          } else if (this.newNotice.type === 'edit') {
            resp = (await API.omsAPI[this.env].clientServer.updateNotice(param, this.protHeaders)).data;
          }
          // console.info('resp:', resp)

          this.sureLoading = false;
          this.newNotice.modal = false
          this.$refs.noticeInfoForm.resetFields()

          if ( resp.retCode ) {
            this.$Notice.error( {
              title: resp.msg,
              desc: '操作失败'
            })
            return
          }
          this.$Notice.success( {
            desc: '操作成功'
          })
          this.getNoticeList()

        } catch(e) {
          this.$Notice.error( {
            desc: '操作失败'
          })
        }
      },

      // 点击发送按钮弹窗提示
      handleSend(noticeId) {
        this.$Modal.confirm({
          title: '是否确认发送',
          content: '发送后XMS-PC终端将收到本通知',
          okText: '立即发送',
          onOk: () => {
            this.sendOrRecall(noticeId, 'send')
          },
        });
      },

      // 点击撤回按钮弹窗提示
      handleRecall(noticeId) {
        this.$Modal.confirm({
          title: '是否撤回通知',
          content: '通知撤回后，XMS-PC终端将不可见',
          okText: '确认撤回',
          onOk: () => {
            this.sendOrRecall(noticeId, 'recall')
          },
        });
      },

      // 发送/撤回公告操作
      async sendOrRecall(noticeId, type) {
        try {
          let resp = {}
          let params = {
            noticeId,
            operator: this.username
          }
          if (type === 'send') {
            resp = (await API.omsAPI[this.env].clientServer.sendNotice(params, this.protHeaders)).data;
          } else if (type === 'recall') {
            resp = (await API.omsAPI[this.env].clientServer.recallNotice(params, this.protHeaders)).data;
          }

          if ( resp.retCode ) {
            this.$Notice.error( {
              title: resp.msg,
              desc: '操作失败'
            })
            return
          }
          this.$Notice.success( {
            desc: '操作成功'
          })
          this.getNoticeList()

        } catch(e) {
          this.$Notice.error( {
            desc: '操作失败'
          })
        }
      },

      // 分页
      changePageSize(pageSize) {
        this.queryParams.pageNum = 1
        this.queryParams.pageSize = pageSize
        this.getNoticeList()
      },
      changePage(pageIndex) {
        this.queryParams.pageNum = pageIndex
        this.getNoticeList()
      },
    }
  }
</script>

<style lang="scss">
  .ivu-checkbox-group {
    display: inline-block;
  }
  .edit-tips {
    float: right;
    margin-right: 59px;
    span {
      &::before {
        content: '';
        width: 6px;
        height: 6px;
        background: #2d8cf0;
        display: inline-block;
        border-radius: 100px;
        margin-right: 3px;
        margin-top: -2px;
        vertical-align: middle;
      }
      &.sp02 {
        &::before {
          background: #52c41a;
        }
      }
      &.sp03 {
        &::before {
          background: #faad14;
        }
      }
    }
  }
  .send-state0, 
  .send-state1, 
  .send-state2 {
    &::before {
      content: '';
      width: 6px;
      height: 6px;
      background: #2d8cf0;
      display: inline-block;
      border-radius: 100px;
      margin-right: 3px;
      margin-top: -2px;
      vertical-align: middle;
    }
    &.send-state2 {
      &::before {
        background: #52c41a;
      }
    }
    &.send-state0 {
      &::before {
        background: #faad14;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/pages/message/notice-list.vue